<h2 class="cdk-visually-hidden">
  {{ 'Links' }}
</h2>
@for (link of links; track link; let i = $index) {
  <div class="link">
    @if (link?.imageUrl) {
      <img [src]="link?.imageUrl" [alt]="link?.title" />
    }
    <h3 class="h2">{{ getLinkTitle(i) | translate }}</h3>
    @if (link?.text) {
      <p class="desc">{{ getLinkText(i) | translate }}</p>
    }
    <p class="button-wrap">
      <a mat-button [href]="link?.url" target="_blank" class="has-icon">
        {{ 'research.portal.homepage.customlink.explore' | translate }}
        <mat-icon class="mat-icon-rtl-mirror" svgIcon="open-in-new"></mat-icon>
      </a>
    </p>
  </div>
}
